var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "holdRuleGroups"
  }, [_c('page-title', {
    attrs: {
      "title": "Hold rule groups",
      "icon": "pe-7s-flag"
    }
  }), _c('div', {
    staticClass: "card mb-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm.groupsDataLoading ? _c('div', {
    staticClass: "col-12"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v(" Hold Groups Ophalen... "), _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)]) : _c('div', {
    staticClass: "col-12"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v(" Hold Groups ")])])])]), _c('div', {
    staticClass: "col-12"
  }, [!_vm.groupsDataLoading ? _c('b-table', {
    attrs: {
      "items": this.groupsData,
      "fields": this.fields,
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function (data) {
        return [_c('div', {
          staticClass: "d-flex flex-row"
        }, [_vm.hasPermission('holdrules.view') ? _c('b-button', {
          staticClass: "btn btn-sm text-body",
          attrs: {
            "to": {
              name: 'holdRuleGroupView',
              params: {
                groupIdentifier: data.item.identifier
              }
            },
            "variant": "link"
          }
        }, [_c('font-awesome-icon', {
          attrs: {
            "icon": "eye"
          }
        })], 1) : _vm._e(), _vm.hasPermission('holdrules.edit') ? _c('b-button', {
          staticClass: "btn btn-sm text-primary",
          attrs: {
            "to": {
              name: 'holdRuleGroupEdit',
              params: {
                groupIdentifier: data.item.identifier
              }
            },
            "variant": "link"
          }
        }, [_c('i', {
          staticClass: "far fa-pencil-alt"
        })]) : _vm._e(), _vm.hasPermission('holdrules.edit') ? _c('b-button', {
          staticClass: "btn btn-sm text-danger",
          attrs: {
            "variant": "link"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteButtonHandler(data.item);
            }
          }
        }, [_c('font-awesome-icon', {
          attrs: {
            "icon": "trash"
          }
        })], 1) : _vm._e()], 1)];
      }
    }], null, false, 628653562)
  }) : _vm._e()], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }